import {get} from '@/lib/axios';

export default {
    async getPages(credentials) {
        return get('/static-pages', credentials);
    },
}
